module.exports = __webpack_public_path__ + "img/other_2.405b3c22.png";